
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSpinner,
    IonIcon,
    IonButton,
    modalController,
    IonButtons,
    IonInput,
    menuController,
} from "@ionic/vue";
import { add, refresh, menu } from "ionicons/icons";

import { ref, computed, onMounted } from "vue";

import { dateFormat } from "@/services/utils";
import { openToast } from "@/services/toast";
import apiPerizie from "@/services/perizie";

import NewPeriziaDetail from "@/components/perizie/NewPeriziaDetail.vue";

export default {
    name: "Perizie",
    components: {
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonPage,
        IonSpinner,
        IonIcon,
        IonButton,
        IonButtons,
        IonInput,
    },
    setup() {
        const loading = ref(false);

        const openMenu = () => {
            menuController.open("app-menu");
        };

        function resolveUserIds() {
            const userInfo = JSON.parse(localStorage.getItem("userInfoAssitech"));

            const isPerito = (
                userInfo
                && userInfo.periti
                && userInfo.periti.length > 0
            ) ? true
            : false;

            const peritoID = isPerito ? userInfo.periti[0].periti_id : userInfo.users_id;

            let userID = userInfo.users_id;
            if (!userID && userInfo.periti && userInfo.periti.length > 0) {
                if (userInfo.periti[0].periti_user) {
                    userID = userInfo.periti[0].periti_user;
                } else if (userInfo.periti[0].periti_users_id) {
                    userID = userInfo.periti[0].periti_users_id;
                }
            }

            return { isPerito, peritoID, userID };
        }

        const perizie = ref([]);
        async function loadPerizie() {
            loading.value = true;
            try {
                const { isPerito, peritoID, userID } = resolveUserIds();
                const response = await apiPerizie.getPerizie(isPerito, peritoID, userID);

                if (response.status === 200 && response.data.status === 0) {
                    perizie.value = response.data.data;
                } else {
                    openToast("Errore durante la richiesta delle perizie", "toast_danger");
                }
            } catch (error) {
                console.error(error);
                openToast("Errore durante la richiesta delle perizie", "toast_danger");
            } finally {
                loading.value = false;
            }
        }

        const searchQuery = ref("");
        const searchedPerizie = computed(() => {
            const term = searchQuery.value.replace(/ /g, "");

            return perizie.value.filter((perizia) => {
                if (perizia.assicurati_nome && perizia.assicurati_cognome) {
                    return (
                        perizia.assicurati_nome
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1 ||
                        perizia.assicurati_cognome
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1 ||
                        (perizia.assicurati_cognome + perizia.assicurati_nome)
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1 ||
                        (perizia.assicurati_nome + perizia.assicurati_cognome)
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1 ||
                        perizia.pratiche_assicurative_protocollo
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1
                    );
                } else if (perizia.assicurati_nome && !perizia.assicurati_cognome) {
                    return (
                        perizia.assicurati_nome
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1 ||
                        perizia.pratiche_assicurative_protocollo
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1
                    );
                } else if (!perizia.assicurati_nome && perizia.assicurati_cognome) {
                    return (
                        perizia.assicurati_cognome
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1 ||
                        perizia.pratiche_assicurative_protocollo
                            .toLowerCase()
                            .replace(/ /g, "")
                            .indexOf(term.toLowerCase().replace(/ /g, "")) != -1
                    );
                }
            });
        });

        /**
         * ! Set correct customer data
         */
        const riferimentoCliente = (perizia) => {
            if (perizia.assicurati_nome && perizia.assicurati_cognome) {
                return `${perizia.assicurati_nome} ${perizia.assicurati_cognome}`;
            } else if (perizia.assicurati_nome && !perizia.assicurati_cognome) {
                return `${perizia.assicurati_nome}`;
            }
            return `${perizia.assicurati_cognome}`;
        };

        /**
         * ! Set correct background for intervento status
         */
        const statoPerizia = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1 || statusId == 9) {
                    //ticket aperti
                    className = "badge_red";
                } else if (statusId == 2 || statusId == 3) {
                    //ticket aperti
                    className = "badge_blue";
                } else if (statusId == 4 || statusId == 5) {
                    //ticket in lavorazione
                    className = "badge_orange";
                } else if (statusId == 6 || statusId == 7) {
                    //ticket in lavorazione
                    className = "badge_green";
                }
                return className;
            };
        });

        /**
         * ! Open perizia detail
         */
        async function periziaDetail(perizia) {
            const modal = await modalController.create({
                //component: PeriziaDetail,
                component: NewPeriziaDetail,
                componentProps: {
                    data: perizia,
                },
                backdropDismiss: false,
            });
            return modal.present();
        }

        onMounted(() => {
            //GET INTERVENTI DATA
            //loadInterventi();
            loadPerizie();
        });

        return {
            loading,
            add,
            refresh,
            //getRichieste,
            openMenu,
            menu,
            //Dati interventi
            statoPerizia,
            loadPerizie,
            dateFormat,
            riferimentoCliente,
            perizie,
            periziaDetail,
            searchQuery,
            searchedPerizie,
        };
    },
};
